"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoverColor = exports.getBackgroundColor = exports.getBorderColor = void 0;
var theme_1 = __importDefault(require("../../../styles/theme"));
var styleUtilities_1 = require("../../../util/styleUtilities");
function getBorderColor(color, isActive, hasDarkBorder, isExpanded) {
    if (isActive) {
        return color;
    }
    if (hasDarkBorder && !isExpanded) {
        return theme_1.default.colors.dark;
    }
    if (isExpanded) {
        return (0, styleUtilities_1.withOpacity)(theme_1.default.colors.dark, 0.08);
    }
    return 'transparent';
}
exports.getBorderColor = getBorderColor;
function getBackgroundColor(color, isActive, isExpanded) {
    if (isActive) {
        return (0, styleUtilities_1.withOpacity)(color, 0.1);
    }
    if (isExpanded) {
        return theme_1.default.colors.globalBackgroundLight;
    }
    return 'white';
}
exports.getBackgroundColor = getBackgroundColor;
function getHoverColor(color, isActive) {
    return isActive ? 'default' : color;
}
exports.getHoverColor = getHoverColor;
